import { useQuery } from '@apollo/client';
import { GET_MY_FAVORITES } from '../../graphql/games';
import useMainStore from '../../store/mainState';
import { GameItem } from '../../components/ui/gameItem';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as FavoritesIcon } from '../../assets/icons/favorites.svg';
import { useTranslation } from 'react-i18next';

const Favorites = () => {
    const { t } = useTranslation();
    const { labelData, setMainContentWidth } = useMainStore();
    const navigate = useNavigate();
    const mainScreen = useRef<HTMLDivElement>(null);
    const { data: favorites, refetch, loading } = useQuery(GET_MY_FAVORITES, {
        variables: {
            labelId: labelData?.id,
            skip: !labelData,
        },
    });

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            const { width } = entries[0].contentRect;
            setMainContentWidth(width);
        });
        if (mainScreen.current) {
            observer.observe(mainScreen.current);
        }
        return () => observer.disconnect();
    }, []);

    const gameCount = favorites?.myFavorites?.favorites?.length || 0;

    return (
        <div className="main-screen pb-[40px]" ref={mainScreen}>
            {/* Header */}
            <div className="mb-[24px]">
                <h1 className="text-[28px] md:text-[36px] font-extrabold text-white tracking-tight">{t('favorites.title')}</h1>
                {gameCount > 0 && (
                    <p className="text-white/30 text-[14px] mt-[4px]">{t('favorites.gamesSaved', { count: gameCount })}</p>
                )}
            </div>

            {loading ? (
                <div className="flex items-center justify-center h-[300px]">
                    <div className="w-[44px] h-[44px] border-[3px] border-white/10 border-t-[#0086D3] rounded-full animate-spin"></div>
                </div>
            ) : gameCount > 0 ? (
                <div className="flex flex-row flex-wrap">
                    {favorites.myFavorites.favorites.map((favorite: any) => (
                        <GameItem game={favorite.game} key={favorite.game.id} />
                    ))}
                </div>
            ) : (
                /* Empty state */
                <div className="flex flex-col items-center justify-center py-[80px]">
                    <div className="w-[80px] h-[80px] rounded-full bg-white/[0.04] border border-white/[0.06] flex items-center justify-center mb-[20px]">
                        <FavoritesIcon className="w-[36px] h-[36px] [&_*]:fill-white/20" />
                    </div>
                    <h2 className="text-white text-[20px] font-bold mb-[8px]">{t('favorites.noFavoritesYet')}</h2>
                    <p className="text-white/30 text-[14px] text-center max-w-[300px] mb-[24px]">
                        {t('favorites.tapHeartIcon')}
                    </p>
                    <button
                        onClick={() => navigate('/casino')}
                        className="px-[24px] py-[12px] rounded-[12px] bg-gradient-to-r from-[#4DBDFF] to-[#0086D3] text-white font-semibold text-[14px] hover:shadow-[0_4px_25px_rgba(0,134,211,0.35)] hover:scale-[1.02] transition-all duration-300"
                    >
                        {t('favorites.browseGames')}
                    </button>
                </div>
            )}
        </div>
    )
}

export default Favorites
